import styled, { css } from 'styled-components';

const MOBILE_IMG_HEIGHT = '395px';

export const Wrapper = styled.div<{ isMobile: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: fit-content;
  background-color: ${({ isMobile, theme }) => isMobile && theme.COLOR.GREY_BG};
`;

export const Text = styled.span<{
  bold?: boolean;
  hidden?: boolean;
  isMobile?: boolean;
}>`
  display: ${({ hidden }) => hidden && 'none'};
  text-align: ${({ isMobile }) => !isMobile && 'center'};
  ${({ theme }) => theme.FONT.H3}
  color: ${({ theme }) => theme.COLOR.WHITE};
  line-height: 34px;
  font-weight: ${({ bold }) => (bold ? '700' : '400')};
  margin-top: ${({ bold }) => !bold && '110px'};
  margin-bottom: ${({ bold }) => !bold && '26px'};
  margin-left: ${({ isMobile }) => isMobile && '-50px'};
  z-index: 3;
`;

export const SearchButtonWrapper = styled.div<{
  isOpen: boolean;
  isMobile: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: ${({ isMobile }) => (isMobile ? '320px' : '384px')};
  padding: 13px 33px;
  margin-top: ${({ isOpen }) => isOpen && '44px'};
  margin-bottom: ${({ isOpen, isMobile }) =>
    isOpen ? '363px' : isMobile ? '120px' : '203px'};
  background-color: ${({ theme }) => theme.COLOR.WHITE};
  border-radius: 30px;
  cursor: pointer;
  z-index: ${({ isOpen }) => (isOpen ? '10' : '3')};
`;

export const ButtonText = styled.p`
  ${({ theme }) => theme.FONT.B1};
  user-select: none;
`;

export const ButtonImg = styled(`img`)``;

export const BackgroundImageWrapper = styled.div<{ isMobile: boolean }>`
  display: flex;
  flex-direction: ${({ isMobile }) => (isMobile ? 'column' : 'row')};
  width: ${({ isMobile }) => (isMobile ? '320px' : '1200px')};
  align-items: center;
  gap: 24px;
  margin-top: 40px;
  z-index: 1;
  overflow: hidden;

  ${({ isMobile }) =>
    isMobile &&
    css`
      left: 0;
      transform: none;
      margin-bottom: 0;
    `}
`;

export const BackgroundImageFilter = styled.div<{ isMobile: boolean }>`
  position: absolute;
  display: flex;
  justify-content: center;
  top: 0;
  left: 50%;
  width: ${({ isMobile }) => isMobile && '100%'};
  min-width: ${({ isMobile, theme }) => !isMobile && theme.WIDTH.PC_LAYOUT};
  height: ${({ isMobile, theme }) =>
    isMobile ? `calc(${theme.HEIGHT.MOBILE_HEADER} + 400px)` : '380px'};
  border-radius: ${({ isMobile }) => !isMobile && '10px'};
  background: rgba(0, 0, 0, 0.2);
  transform: translateX(-50%);
  z-index: 2;

  ${({ isMobile }) =>
    isMobile &&
    css`
      left: 0;
      transform: none;
      height: ${MOBILE_IMG_HEIGHT};
    `}
`;

export const SectionTitle = styled.p`
  ${({ theme }) => theme.FONT.H3};
`;

export const BannerSection = styled.div<{ isMobile: boolean }>`
  display: flex;
  width: ${({ theme, isMobile }) =>
    isMobile ? theme.WIDTH.MOBILE_LAYOUT : theme.WIDTH.PC_LAYOUT};
  margin-top: ${({ isMobile }) => !isMobile && '80px'};

  ${({ isMobile }) =>
    isMobile &&
    css`
      margin-bottom: 20px;
      padding: 0 20px;
    `}
`;

export const BannerWrapper = styled.div<{ isMobile: boolean }>`
  position: relative;
  width: 100vw;
  height: 300px;
  margin-top: 40px;
  background-color: #453a39;

  ${({ isMobile }) =>
    isMobile &&
    css`
      height: 384px;
      margin-top: 0;
    `}
`;

export const ImgWrapper = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  top: 0;
  left: 50%;
  width: 100%;
  max-width: 1500px;
  transform: translateX(-50%);
`;
